/*-------------  SLIDE 1 animation  -------------*/

var correctCards = 0;
function handleCardDrop( event, ui ) {
  var slotNumber = $(this).data( 'number' );
  var cardNumber = ui.draggable.data( 'number' );
  if ( slotNumber == cardNumber ) {
    ui.draggable.addClass( 'correct' );
    ui.draggable.draggable( 'disable' );
    $(this).droppable( 'disable' );
    ui.draggable.position( { of: $(this), my: 'center center', at: 'center center' } );
    ui.draggable.draggable( 'option', 'revert', false );
    correctCards++;
    $("#slotLabel"+slotNumber).css( "display", "block" );
    //$("#card"+slotNumber).css( "display", "none" );  
    var kapkaBox = document.getElementById("kapkaOK");
    TweenMax.to(kapkaBox, 1, {x:0, y:-185,  ease:Quint.easeOut});
    TweenMax.to(kapkaBox, 0.5, {autoAlpha:1});

    setInterval(function(){
      TweenMax.to(kapkaBox, 1, {x:0, y:0,  ease:Quint.easeOut});
      TweenMax.to(kapkaBox, 0.5, {autoAlpha:1});
    }, 5000);
  }

  if ( correctCards == 12 ) {
    var endBox = document.getElementById("endBox");
    TweenMax.to(endBox, 1, {x:0, y:755,  ease:Quint.easeOut});
    TweenMax.to(endBox, 0.5, {autoAlpha:1});
    $("#banner_box").css( "z-index", "3" );

    returnHome('#zpet_btn','#slide1','');

    $('#znovu_btn').on("click", function() {
      $("#banner_box").css( "z-index", "1" );
      $("#banner_box").html('');
      /*$("#slide1").html('');
      $("#slide1").fadeOut( "slow", function() { });*/
      slide1_anima();
    });
  }

}

function slide1_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var listecek = [];

  $("#banner_box").html(bmcont);
  $("#banner_box").css( "z-index", "1" );

	 $(".slide").html('');

		bmcont = '<div id="slide1Start" style="display: none;"><div id="startBox">'+jsondata["sl1_txt"]+'</div></div><div id="moveHome"></div><div id="sl1_cnt" class="sl_cnt"><div id="cardPlocha"><div id="cardPile"> </div><div id="cardSlots"> </div></div></div><div id="sl1_kapka"></div><div id="sl1_footer"></div><div id="sl1_foo" class="menu_bott"></div>';

    //bmcont = '<div id="slide1Start" style="display: none;"><div id="startBox">'+jsondata["sl1_txt"]+'</div></div><div id="moveHome"></div><div id="sl1_cnt" class="sl_cnt"></div><div id="sl1_foo" class="menu_bott"></div>';

		$("#slide1").html(bmcont);

		homepage = '<div id="moveHead"><span class="head-icon"></span><h1>'+jsondata["sl1_head"]+'</h1></div>';
		$("#moveHome").html(homepage);

    startBox(755);

    $('#slide1StartBtn').on("click", function() {
      var helpBox = document.getElementById("helpBox");
      TweenMax.to(helpBox, 1, {x:0, y:0,  ease:Quint.easeOut});
      TweenMax.to(helpBox, 0.5, {autoAlpha:1});
      $( "#slide1Start" ).fadeOut( "slow", function() {
      });
    });

    returnHome('#moveHome','.slide','');

    bmcont = '<div class="pozadi-grey">';
    pocet = jsondata["sl1_banner"].length;
    for (i=0; i<pocet; i++) {
      bmcont += jsondata["sl1_banner"][i];
    }
    bmcont += '</div>';

    $("#banner_box").html(bmcont);

    bmcont = '<div class="kapkaOK" id="kapkaOK"></div><div class="kapkaKO" id="kapkaKO"></div>';
    $("#sl1_kapka").html(bmcont);

    bmcont = '<div class="pozadi_footer" id="nalepky"></div>';
    $("#sl1_footer").html(bmcont);


    // Reset the game
    correctCards = 0;
    $('#cardPile').html( '' );
    $('#cardSlots').html( '' );

    var nalepkyBox = document.getElementById("nalepky");
    TweenMax.to(nalepkyBox, 1, {x:0, y:-217,  ease:Quint.easeOut});
    TweenMax.to(nalepkyBox, 0.5, {autoAlpha:1});


    pocet = jsondata["sl1_listecky"].length + 1;
    for (i=1; i<pocet; i++) {
      listecek[i] = jsondata["sl1_listecky"][i-1];
    }

    // Create the pile of shuffled cards
    var numbers = [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 ];
    numbers.sort( function() { return Math.random() - .5 } );
    var a = 0;
    var slotLabel = [];

    for ( var i=0; i<12; i++ ) {
      a = i+1;
      $('<div class="cardpos'+i+'"><span>' + listecek[numbers[i]] + '</span></div>').data( 'number', numbers[i] ).attr( 'id', 'card'+numbers[i] ).appendTo( '#cardPile' ).draggable( {
        containment: '#cardPlocha',
        stack: '#cardPile div',
        cursor: 'move',
        revert: true
      } );
      $('<div class="card_dock'+i+' card_dock"><span>' + listecek[numbers[i]] + '</span></div>').data( 'number', numbers[i] ).attr( 'id', 'card'+numbers[i]+'_dock' ).appendTo( '#cardPile' );
      slotLabel[numbers[i]] = listecek[numbers[i]];
    }

    // Create the card slots
    var words = jsondata["sl1_listecky"];
    for ( var i=1; i<=12; i++ ) {
      $('<div id="slot'+i+'"><span id="slotLabel'+i+'" class="slotLabel" style="display:none;">'+slotLabel[i]+'</span></div>').data( 'number', i ).appendTo( '#cardSlots' ).droppable( {
        accept: '#cardPile div',
        hoverClass: 'hovered',
        drop: handleCardDrop
      } );
    }

/*stop*/







/*
		if (banners == '') {
			banners = '<div id="banners_sl1"></div>';
			pocet = jsondata["sl1_btnlabs"].length + 1;
			for (i=1; i<pocet; i++) {
				banners += '<div id="banner_sl1'+i+'" class="banner">';
				banners += '<h2>'+jsondata["sl1_btnlabs"][i-1]+'</h2>';
				banners += '<div class="banner_text">'+jsondata["sl1_banner"][i-1]+'</div>';
				banners += '<div id="banner_close_sl1_'+i+'" class="banner_close"></div>';
				banners += '</div>';
			}
		}

		$('.ax').hover(function() {
			bmiid = '#'+$(this).attr('id')+'_tt';
			alert(bmiid);
		}, function() {
			console.log("aaaa");
		});


		$(".ax").on("click",function(){
			console.log("aaaaaaa");
		var logo = document.getElementById("logo");
		TweenMax.to(logo, 1, {x:100, y:-100,  ease:Quint.easeOut});
		TweenMax.to(logo, 0.5, {autoAlpha:1});
		});
		$(".as").click(function(e) {
		//TweenMax.staggerTo(".box", 1, {rotation:360, y:100}, 0.5);
		var logo = document.getElementById("logo");
		TweenMax.to(logo, 1, {x:0, y:0,  ease:Quint.easeOut});
		TweenMax.to(logo, 0.5, {autoAlpha:0});
		});
*/
	$('#slide1').fadeIn(1000);




/*
	$('.btnlab').hover(function() {
		id = $(this).attr('id');
		$(this).addClass("active");
		switch (id) {
			case 'sl1point5':
				$('#sl1st2_ban1').show();
			break;
			case 'sl1st2bt2':
				$('#sl1st2_ban2').show();
			break;
		}
	}, function() {
		$('.bantyp1').hide();
	});


	$('.bmi').hover(function() {
		bmiid = '#'+$(this).attr('id')+'_tt';
		$(bmiid).show();
	}, function() {
		$('.bmitt').hide();
	});

	$('#b1').on('click'), function () {
		$('#banners_sl1').fadeOut(1000);
		var id = $(this).attr("id");
		consol.log(id);
		//$(this).addClass("active");
		$("#banners_sl1").html('#'+id);
	}*/


	$(".bmi").on("click", function(){
		var id = $(this).attr("id");
		$(".bmi").removeClass('active');
		$(this).addClass("active");

			switch (id) {
			case "sl1_bmi1":
				cont = '<div id="sl1_block"><div id="sl1_hl" class="headline">'+jsondata["sl1_headline"][0]+'</div>';
				cont += jsondata['sl1_steps'][0];
				cont += '</div>';
			break;
			case "sl1_bmi2":
				cont = '<div id="sl2_block"><div id="sl1_hl" class="headline">'+jsondata["sl1_headline"][1]+'</div>';
				cont += jsondata['sl1_steps'][1];
				cont += '</div>';
				//cont += cont12i;
			break;
			case "sl1_bmi3":
				cont = '<div id="sl3_block"><div id="sl1_hl" class="headline">'+jsondata["sl1_headline"][2]+'</div>';
				cont += jsondata['sl1_steps'][2];
				cont += '</div>';
			break;
			case "sl1_bmi4":
				cont = '<div id="sl4_block"><div id="sl1_hl" class="headline">'+jsondata["sl1_headline"][3]+'</div>';
				cont += jsondata['sl1_steps'][3];
				cont += '</div>';
			break;
			case "sl1_bmi5":
				cont = '<div id="sl5_block"><div id="sl1_hl" class="headline">'+jsondata["sl1_headline"][4]+'</div>';
				cont += jsondata['sl1_steps'][4];
				cont += '</div>';
				cont += banners;
			break;
		};

			$("#sl1_cnt").html(cont);

				$('#sl1st2bt1').on("click", function() {
					$('.btnlab').removeClass('active');
					$('#sl1st2bt1').addClass('active');
					$('.bantyp1').hide();
					$('#sl1st2_ban1').show();
				});
				$('#sl1st2bt2').on('click', function() {
					$('.btnlab').removeClass('active');
					$('#sl1st2bt2').addClass('active');
					$('.bantyp1').hide();
					$('#sl1st2_ban2').show();
				});

				$('#sl1st3bt1').on("click", function() {
					$('.btnlab').removeClass('active');
					$('#sl1st3bt1').addClass('active');
					$('.bantyp1').hide();
					$('#sl1st3_ban1').show();
				});
				$('#sl1st3bt2').on('click', function() {
					$('.btnlab').removeClass('active');
					$('#sl1st3bt2').addClass('active');
					$('.bantyp1').hide();
					$('#sl1st3_ban2').show();
				});

				$('#sl1st4bt1').on("click", function() {
					$('.btnlab').removeClass('active');
					$('#sl1st4bt1').addClass('active');
					$('.bantyp1').hide();
					$('#sl1st4_ban1').show();
				});
				$('#sl1st4bt2').on('click', function() {
					$('.btnlab').removeClass('active');
					$('#sl1st4bt2').addClass('active');
					$('.bantyp1').hide();
					$('#sl1st4_ban2').show();
				});

				$('#sl1st5bt1').on("click", function() {
					$('.btnlab').removeClass('active');
					$('#sl1st5bt1').addClass('active');
					$('.bantyp1').hide();
					$('#sl1st5_ban1').show();
				});
				$('#sl1st5bt2').on('click', function() {
					$('.btnlab').removeClass('active');
					$('#sl1st5bt2').addClass('active');
					$('.bantyp1').hide();
					$('#sl1st5_ban2').show();
				});

				$('#box1').on("click", function() {
					var logo = document.getElementById("logo");
					TweenMax.to(logo, 1, {x:100, y:-100,  ease:Quint.easeOut});
					TweenMax.to(logo, 0.5, {autoAlpha:1});
				});
				$('#box2').on("click", function() {
					var logo = document.getElementById("logo");
					TweenMax.to(logo, 1, {x:0, y:0,  ease:Quint.easeOut});
					TweenMax.to(logo, 0.5, {autoAlpha:0.5});
				});




/*
				$('#sl1st6bt1').on("click", function() {
					$('.btnlab').removeClass('active');
					$('#sl1st6bt1').addClass('active');
					$('.bantyp1').hide();
					$('#sl1st6_ban1').show();
				});

				$('.bantyp1').on('click', function() {
					$('.bantyp1').hide();
					$('.btnlab').removeClass('active');
				});
				$('.bantyp2').on('click', function() {
					$('.bantyp2').hide();
					$('.btnlab').removeClass('active');
				});

*/

	});

}
